import styled from 'styled-components';

export const WrapperBox = styled.div(
  props => `
    border:1px solid #e1e1e1;
    border-radius: 0.3rem;
    width: 27rem;
    display:flex;
    background: white;
    flex-direction: column;
    max-height: 37rem;
    overflow-y: scroll;
    padding: 1rem;
    margin-right: 2rem; 
    
    &::-webkit-scrollbar {
        width: 3px;
    }
    
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    
    &::-webkit-scrollbar-thumb {
        background: #e1e1e1; 
        border-radius: 20px;
    }
`,
);

export const RestStopsBox = styled.div`
  border: 1px solid #e1e1e1;
  border-radius: 0.3rem;
  width: 22.5rem;
  display: flex;
  background: white;
  flex-direction: column;
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 4rem;
`;
export const Header = styled.h3`
  font-size: 1.4rem;
  color: black;
  font-weight: bold;
  padding-bottom: 2rem;
`;
export const RestStopsWrap = styled.section`
  border-left: 1px dashed #ccc;
  padding: 0 2rem;
`;
